import { useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import { useUser } from '@/lib/auth';
import { useFetchCategoryInfoByCountryCode } from '@/shared/category';
import { useCreateSubjectNameGetter } from '@/shared/category/useCreateSubjectNameGetter';
import { useFetchMyQuizes } from '@/shared/features/quiz-list/hooks';
import { QuizListItem } from './QuizListItem';
export const NextQuizsetSelect = ({
  excludeQuizsetIds,
  onSelect
}: {
  excludeQuizsetIds: string[];
  onSelect: (quizsetId: string) => void;
}) => {
  const {
    data,
    fetchNextPage,
    hasNextPage
  } = useFetchMyQuizes();
  const {
    user
  } = useUser();
  const {
    categoryTreeData
  } = useFetchCategoryInfoByCountryCode(user?.countryCode as string);
  const flatData = useMemo(() => data?.pages.flatMap(page => page.data ?? []) ?? [], [data]);
  const subjectNameGetter = useCreateSubjectNameGetter(categoryTreeData?.subjectTree);
  const {
    ref,
    inView
  } = useInView({
    rootMargin: '20px'
  });
  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, hasNextPage]);
  return <div className="divide-y divide-gray-200 px-lg max-mobile-lg:px-md
    " data-sentry-component="NextQuizsetSelect" data-sentry-source-file="NextQuizsetSelect.tsx">
      {flatData.filter(quizset => !excludeQuizsetIds.includes(quizset.id)).map(quizset => <QuizListItem key={quizset.id} item={quizset} subjectName={subjectNameGetter({
      subjectGroupId: quizset.categoryInfo?.subject,
      subSubjectGroupId: quizset.categoryInfo?.subSubject
    })} onSelect={onSelect} />)}
      <div ref={ref} />
    </div>;
};